export const newEmployerCertificate = {
  // Page Title and Headers
  EMPLOYER_CERTIFICATE_PAGE_TITLE: "Employer Certificate",
  EMPLOYER_CERTIFICATE_HEADING: "Employer Certificate",
  EMPLOYER_CERTIFICATE_DESCRIPTION: "Generate and download your employer certificate",
  
  // Employer Certificate Header
  "Employer Certificate": "Employer Certificate",
  "employerCertificateTutorial":"See how can we order an employer certifcate",
  "employerCertificateWatch": "Watch",
  "employerCertificateDescription": "When you have received your first salary from us, you can request  an employment certificate. An employment certificate may be needed when  applying for unemployment benefits. It is important that you fill in  your hours and the salary you receive from us, so please verify this  with your payslips from us. This will allow your employment certificate  to be reviewed by us and approved for our signature. Once we have  approved and signed it, you will receive an email you that can log  in and retrieve it from your portal.",
  
  // Work Hours Required
  "Work Hours Required": "Work Hours Required",
  "workHoursRequiredDescription": "To generate an Employer Certificate, you need registered work hours in your Timesheet. If you haven't logged any hours yet, please add them first.",
  "Create Timesheet": "Create Timesheet",
  
  // Certificates Table
  "Your certificates": "Your certificates",
  "Search": "Search",
  "Date from": "Date from",
  "Date to": "Date to",
  "Order Certificate": "Order Certificate",
  "Duration": "Duration",
  "Issued Date": "Issued Date",
  "Edit": "Edit",
  "Download": "Download",
  "Delete": "Delete",
  "No data found": "No data found",

  // Delete Confirmation Modal
  "Delete Certificate": "Delete Certificate",
  "Are you sure you want to delete this certificate?": "Are you sure you want to delete this certificate?",
  "This action cannot be undone.": "This action cannot be undone.",
  "Yes, Delete": "Yes, Delete",
  "Cancel": "Cancel",
  
  // Certificate Information
  CERTIFICATE_INFO: "Certificate Information",
  EMPLOYMENT_PERIOD: "Employment Period",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  CERTIFICATE_TYPE: "Certificate Type",
  CERTIFICATE_DATE: "Certificate Date",
  
  // Actions
  GENERATE_CERTIFICATE: "Generate Certificate",
  DOWNLOAD_CERTIFICATE: "Download Certificate",
  PREVIEW_CERTIFICATE: "Preview Certificate",
  REQUEST_CERTIFICATE: "Request Certificate",
  
  // Certificate Details
  EMPLOYER_NAME: "Employer Name",
  EMPLOYEE_NAME: "Employee Name",
  POSITION: "Position",
  EMPLOYMENT_TYPE: "Employment Type",
  FULL_TIME: "Full Time",
  PART_TIME: "Part Time",
  
  // Status Messages
  CERTIFICATE_GENERATED_SUCCESS: "Certificate generated successfully",
  CERTIFICATE_DOWNLOAD_SUCCESS: "Certificate downloaded successfully",
  CERTIFICATE_REQUEST_SENT: "Certificate request sent successfully",
  NO_CERTIFICATES_FOUND: "No certificates found",
  LOADING_CERTIFICATES: "Loading certificates...",
  
  // Form Labels
  SELECT_PERIOD: "Select Period",
  CUSTOM_PERIOD: "Custom Period",
  CURRENT_YEAR: "Current Year",
  LAST_YEAR: "Last Year",
  ALL_TIME: "All Time",
  
  // Table Headers
  CERTIFICATE_LIST: "Certificate List",
  ISSUE_DATE: "Issue Date",
  PERIOD: "Period",
  STATUS: "Status",
  ACTIONS: "Actions",
  
  // Certificate Status
  PENDING: "Pending",
  APPROVED: "Approved",
  READY: "Ready",
  DOWNLOADED: "Downloaded",
  
  // Validation Messages
  PLEASE_SELECT_START_DATE: "Please select a start date",
  PLEASE_SELECT_END_DATE: "Please select an end date",
  END_DATE_MUST_BE_AFTER_START: "End date must be after start date",
  "Start date is required": "Start date is required",
  "End date is required": "End date is required",
  "Year is required": "Year is required",
  "Amount is required": "Amount is required",
  
  // Additional Info
  CERTIFICATE_PURPOSE: "Purpose of Certificate",
  ADDITIONAL_NOTES: "Additional Notes",
  OPTIONAL: "Optional",
  
  // New Order Form
  "Create New Order": "Create New Order",
  "Important": "Important",
  "All information you enter in the Employer Certificate will appear in Swedish in the final certificate.": "All information you enter in the Employer Certificate will appear in Swedish in the final certificate.",
  "Contract No.": "Contract No.",
  "Emp. name": "Emp. name",
  "Social Security Number": "Social Security Number",
  "12 digits": "12 digits",
  "Employment Details": "Employment Details",
  "Employment period": "Employment period",
  "Start date": "Start date",
  "End date": "End date",
  "Currently working": "Currently working",
  "Work Hours Recorded": "Work Hours Recorded",
  "All registered working hours entered in the Timesheet section and/or referenced in invoices are displayed here.": "All registered working hours entered in the Timesheet section and/or referenced in invoices are displayed here.",
  "Month/Year": "Month/Year",
  "Avg. Work Duration": "Avg. Work Duration",
  "Absence": "Absence",
  "Over Time": "Over Time",
  "Total Amount": "Total Amount",
  "Avg. Over Time": "Avg. Over Time",
  "Leave Days": "Leave Days",
  "Avg. Break Duration": "Avg. Break Duration",
  "Total Working Days": "Total Working Days",
  
  // Discontinuation Details
  "Discontinuation Details": "Discontinuation Details",
  "Reason why the employment has ended in whole or in part": "Reason why the employment has ended in whole or in part",
  "Reason type": "Reason type",
  "Describe reason": "Describe reason",
  "Type here...": "Type here...",
  "Select reason": "Select reason",
  "Other reason": "Other reason",
  "Contract ended": "Contract ended",
  "Resignation": "Resignation",
  "Termination": "Termination",
  "Resignation by employee": "Resignation by employee",
  "Termination by employer": "Termination by employer",
  "Mutual agreement": "Mutual agreement",
  "End of assignment": "End of assignment",
  "Retirement": "Retirement",
  "Redundancy / Laid off": "Redundancy / Laid off",
  "You are currently employed, so you cannot add a reason": "You are currently employed, so you cannot add a reason",
  
  // Salary Information
  "Information about the salary": "Information about the salary",
  "Year": "Year",
  "Select year": "Select year",
  "Hourly salary": "Hourly salary",
  "Salary type": "Salary type",
  "Hourly": "Hourly",
  "salaryTypeTooltip": "Employer certificates at Invozio are issued exclusively for hourly-wage employees. No other salary type can be selected.",
  "Amount": "Amount",
  "Enter amount": "Enter amount",
  
  // Other Information
  "Other information": "Other information",
  "otherInfoDescription": "The individual has been employed by Invozio during the stated period and has not conducted business as a self-employed person within the scope of the assignment. All work has been performed as an employee of Invozio, which has acted as the formal employer and has been responsible for salary payments, tax deductions, employer contributions, and reporting to the Swedish Tax Agency. The individual is therefore to be regarded as an employee, not a self-employed contractor, in this context.",
  "seeAppendix": "See appendix 'Other information'.",
  "confirmAccurate": "I confirm that all information provided for the employment certificate is accurate and complete to the best of my knowledge. I understand that incorrect or incomplete information may affect my eligibility for unemployment benefits or other public compensation, and that I am personally responsible for the submitted information and any consequences arising from inaccuracies.",
  
  // Footer
  "Cancel": "Cancel",
  "Submitemployercertifcate": "Create",
  "Update": "Update",
  "Save Draft": "Save Draft",
  "Update Draft": "Update Draft",
  "Saving...": "Saving...",
  "employerCertificateCreatedSuccessfully": "Employer certificate created successfully",
  "employerCertificateUpdatedSuccessfully": "Employer certificate updated successfully",
  "employerCertificateDeletedSuccessfully": "Employer certificate deleted successfully",
  "somethingWentWrong": "Something went wrong",
  "Draft saved successfully": "Draft saved successfully",
  "Failed to save draft": "Failed to save draft",
  "Draft updated successfully": "Draft updated successfully",
  "Failed to update draft": "Failed to update draft",

  // Draft Certificate
  "Draft Employer Certificate": "Draft Employer Certificate",
  "Are you sure you want to delete this Draft Employer Certificate?": "Are you sure you want to delete this Draft Employer Certificate?",
  "Present": "Present",

  // Work Hours Empty State
  "No data found for selected period": "No data found for selected period",
  "You can still fill the fields manually if needed.": "You can still fill the fields manually if needed.",
  "No Data": "No Data",
  "No data": "No data",
};
